import { render, staticRenderFns } from "./AK4Icon.vue?vue&type=template&id=8bbac690&scoped=true&"
import script from "./AK4Icon.vue?vue&type=script&lang=js&"
export * from "./AK4Icon.vue?vue&type=script&lang=js&"
import style0 from "./AK4Icon.vue?vue&type=style&index=0&id=8bbac690&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bbac690",
  null
  
)

export default component.exports